import pluralize from 'pluralize'

import { ProgressBar } from '@/components/ui'
import type { FileRead } from '../trialCut'

const PERCENT = 100

const ReadOutcome = ({ pagesRead, pagesUnread }: FileRead) => {
  if (pagesUnread === 0)
    return (
      <strong className="font-semibold text-brand-deep">all extracted</strong>
    )
  if (pagesRead === 0)
    return <span>not extracted, kept for after you upgrade</span>
  return (
    <>
      <strong className="font-semibold text-brand-deep">
        first {pagesRead} extracted
      </strong>
      , {pagesUnread} kept, not extracted
    </>
  )
}

interface FileReadRowProps {
  position: number
  fileRead: FileRead
}

export const FileReadRow = ({ position, fileRead }: FileReadRowProps) => {
  const { statement, pagesRead } = fileRead
  const pages = statement.numberOfPages

  return (
    <li className="flex flex-col gap-2 px-4 py-3.5">
      <div className="flex items-center justify-between gap-3 text-sm">
        <span className="inline-flex min-w-0 items-center gap-2 font-medium">
          <span className="text-xs tabular-nums text-muted-foreground">
            {position}
          </span>
          <span className="truncate">{statement.fileName}</span>
        </span>
        <span className="shrink-0">
          {pages} {pluralize('page', pages)}, <ReadOutcome {...fileRead} />
        </span>
      </div>
      <ProgressBar
        progress={(pagesRead / pages) * PERCENT}
        className="h-1.5 bg-muted"
        progressClassName="h-1.5"
      />
    </li>
  )
}
